import React from 'react';

export const Price = ({ value, currency = 'UAH', convertTo = 'UAH', currencySymbol = '₴' }) => {
    let amount = parseFloat(value).toFixed(2);
    if (isNaN(amount)) {
        amount = '-';
    }

    return `${amount} ${currencySymbol}`
};
